'use client';

import { useContext, useEffect, useRef, useState } from "react";
import FloatDialog from "./_floatDialog";
import { SignContext } from "@/context/signContext";
import { AuthContext } from "@/context/authContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleRight } from "@fortawesome/free-solid-svg-icons";
import default_profile from "@/public/image/etc/icon_user.png"
import api from "@/util/api";
import customAlert from "@/util/customAlert";
import { useTranslations } from "next-intl";

export default function FloatProfileChange() {
    const { changeProfileShow, setChangeProfileShow } = useContext(SignContext);
    const { user, setUser } = useContext(AuthContext);
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);
    const [file, setFile] = useState<File | null>();

    const fileRef = useRef<HTMLInputElement>(null)

    const t = useTranslations("Text")
    const a = useTranslations("Sentence")

    
    useEffect(() => {
        if (!user.is_authenticated) {
            setChangeProfileShow(false)
        }
    }, [user, setChangeProfileShow]);

    function profileChange() {
        if (!user.is_authenticated) return;
        if (!file) {
            customAlert(a("InvalidImage"), 'warning')
            return;
        }

        const formData = new FormData()
        formData.set('profile_image', file)
        formData.set('username', user.id)
        api(`/api/user/edit/profile/`, { method: "POST", body: formData })
            .then(res => res.json())
            .then(({ status, status_code, message, data }) => {
                customAlert(message, status, () => {
                    if (status_code == 200) {
                        setChangeProfileShow(false)
                        const newUser = user
                        newUser.profile_image_url = data.object.profile_image_url
                        setUser(newUser)
                    }
                })
            })
    }

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFile = e.target.files?.[0];
        if (!selectedFile) return;

        const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
        const fileExtension = selectedFile.name.split('.').pop()?.toLowerCase();

        if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
            customAlert(a("UnsupportedFileFormat"), 'warning');
            return;
        }

        setFile(selectedFile);
        const url = URL.createObjectURL(selectedFile);
        setPreviewUrl(url);
    };

    const handleOpenFileSelect = () => {
        if (!fileRef.current) return;

        fileRef.current.click();
    }

    // if (!user.is_authenticated) {
    //     setChangeProfileShow(false)
    //     return null
    // };

    return (
        <FloatDialog
            show={changeProfileShow}
            setShow={setChangeProfileShow}
            className="profile"
        >
            <FloatDialog.Head>{t("프로필 사진 변경")}</FloatDialog.Head>
            <FloatDialog.Body>
                <div className="change-profile-container">
                    <ul>
                        <li>
                            <div className="profile">
                                <img src={(user as any).profile_image_url || default_profile.src} alt="" />
                            </div>
                            <p>{t("현재")}</p>
                        </li>
                        <li>
                            <FontAwesomeIcon icon={faArrowCircleRight} />
                        </li>
                        <li onClick={handleOpenFileSelect}>
                            <div className="profile">
                                {
                                    previewUrl
                                        ? <img src={previewUrl} alt="preview" />
                                        : <img src={default_profile.src} alt="preview" />
                                }
                            </div>
                            <p>{t("변경 후")}</p>
                        </li>
                    </ul>
                    <input type="file" accept="image/*" onChange={handleFileChange} ref={fileRef} />
                    <div className="btns">
                        <button onClick={profileChange}>{t("변경 하기")}</button>
                    </div>
                </div>
            </FloatDialog.Body>
        </FloatDialog>
    );
}